module.exports = __webpack_public_path__ + "static/media/Off-White-c-o-Virgil-Abloh-Yellow-Binder-Clip-Saffiano-Leather-Bag-Lyst.f0cdd3a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Off-White-c-o-Virgil-Abloh-Yellow-Binder-Clip-Saffiano-Leather-Bag-Lyst.png
// module id = 225
// module chunks = 0